import { AfterViewInit, Component, ElementRef, HostListener, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Menu } from '../../core/models/menu.model';
import { SideMenuService } from '../../core/services/side-menu/side-menu.service';

@Component({
  selector: 'app-side-bar-mobile',
  templateUrl: './side-bar-mobile.component.html',
  styleUrl: './side-bar-mobile.component.scss'
})
export class SideBarMobileComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() public menuData: Menu[] = [];

  @ViewChild('closeButton') closeButton?: ElementRef<HTMLButtonElement>;
  @ViewChild('panel') panel?: ElementRef<HTMLElement>;

  private previousFocus: HTMLElement | null = null;

  constructor(
    public sideMenuService: SideMenuService
  ) {}

  ngOnInit() {
    this.previousFocus = document.activeElement as HTMLElement | null;
  }

  ngAfterViewInit() {
    this.closeButton?.nativeElement.focus();
  }

  ngOnDestroy() {
    this.previousFocus?.focus?.();
  }

  /* -------------------------------------------------------------------------- */
  /*                                ANCHOR close                                */
  /* -------------------------------------------------------------------------- */
  // region close
  @HostListener('document:keydown.escape')
  close() {
    this.sideMenuService.showed = false;
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR onResize                               */
  /* -------------------------------------------------------------------------- */
  // region onResize
  @HostListener('window:resize')
  onResize() {
    // Solo al llegar a tableta/escritorio (>= 768px); en celular el resize ocurre al ocultarse la barra del navegador
    if (window.innerWidth >= 768) {
      this.close();
    }
  }

  /* -------------------------------------------------------------------------- */
  /*                              ANCHOR onTab                                  */
  /* -------------------------------------------------------------------------- */
  // region onTab
  @HostListener('keydown.tab', ['$event'])
  @HostListener('keydown.shift.tab', ['$event'])
  onTab(event: Event) {
    this.trapFocus(event as KeyboardEvent);
  }

  /* -------------------------------------------------------------------------- */
  /*                             ANCHOR trapFocus                               */
  /* -------------------------------------------------------------------------- */
  // region trapFocus
  private trapFocus(event: KeyboardEvent) {
    const focusables = Array.from(
      this.panel?.nativeElement.querySelectorAll<HTMLElement>('a[href], button:not([disabled])') ?? []
    );
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && (active === first || !this.panel?.nativeElement.contains(active))) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && (active === last || !this.panel?.nativeElement.contains(active))) {
      event.preventDefault();
      first.focus();
    }
  }

  toggleSubmenu(doc: any) {
    doc.isOpen = !doc.isOpen;
  }

}
